import ListItemStandard from "../ListItemStandard.js";
import ListItemGroupHeader from "../ListItemGroupHeader.js";
import ListItemStandardExpandableTextTemplate from "./ListItemStandardExpandableTextTemplate.js";

// Assigns the template to the component to be used when the feature is preloaded
ListItemStandard.ExpandableTextTemplate = ListItemStandardExpandableTextTemplate;
ListItemGroupHeader.ExpandableTextTemplate = ListItemStandardExpandableTextTemplate;
